type Interpolations = {
  [key: string]: string | number;
};

// see @link{https://lovevery.atlassian.net/wiki/spaces/DPP/pages/2716893201/String+Interpolation} for more information
export default function interpolate(
  text: string | undefined,
  interpolations?: Interpolations,
) {
  if (!text) {
    console.warn(
      '[lovevery-next] interpolate: no text provided, interpolation aborted.',
    );
    return '';
  }

  let textWithInterpolations = text.slice();

  if (interpolations) {
    Object.keys(interpolations).forEach((interpolation) => {
      const searchString = new RegExp(`{{${interpolation}}}`, 'g');

      textWithInterpolations = textWithInterpolations.replace(
        searchString,
        interpolations[interpolation]?.toString() || '',
      );
    });
  }

  return textWithInterpolations;
}
